var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.999 16.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #04be76;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3345",
    "data-name": "Group 3345",
    transform: "translate(-20 -279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_13",
    "data-name": "Subtraction 13",
    className: "cls-1",
    d: "M-3167,6843a8.009,8.009,0,0,1-8-8,8.008,8.008,0,0,1,8-8,8.008,8.008,0,0,1,8,8A8.01,8.01,0,0,1-3167,6843Zm0-11a3,3,0,0,0-3,3,3,3,0,0,0,3,3,3,3,0,0,0,3-3A3,3,0,0,0-3167,6832Z",
    transform: "translate(3195 -6548)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup2);
export default __webpack_public_path__ + "static/media/pickup2.ae470d5074ea0c004d3b9405b83fac42.svg";
export { ForwardRef as ReactComponent };